module.exports = __webpack_public_path__ + "static/assets/05649236fbbcee12a260894921755795.gif";